import React from 'react'
import { Link, useNavigate } from 'react-router-dom';
function calculateAge(birthday) {
    var ageDifMs = Date.now() - birthday;
    var ageDate = new Date(ageDifMs);
    return Math.abs(ageDate.getUTCFullYear() - 1970);
}
const Product = ({ id, name, category, qr_code, stock, removeProduct, product }) => {
    const navigate = useNavigate()
    return (
        <div className='contact mb-3 user-card'>
            <div className='res'>
                <p>{id}</p>
            </div>
            <div className='res'>
                <p title={name}>{String(name).substring(0, 15)}{String(name).length > 15 ? "..." : ""}</p>
            </div>
            <div>
                <p>{category?.name}</p>
            </div>

            <div className='res'>
                <p>{qr_code}</p>
            </div>
            <div>
                {stock == "1" ? "موجود" : "ناموجود"}
            </div>
            <div>
                <button onClick={() => { removeProduct(id) }}>حذف</button>
                <button style={{ backgroundColor: "#6083FF", marginTop: "10px" }} onClick={() => navigate('/panel/admin/editProduct', { state: product })}>ویرایش</button>
            </div>
        </div>

    );
}
export default Product